<template lang="pug">
div
	page-header(:title='title', :url='url', :titleNew='titleNew')
	.row
		.col-md-4
			input-form-text(textInput='Título', :required='true', v-model='filtro.title', :value='filtro.title' :layout="false")
		.col-md-3
		.col-md-4
		.col-md-1
			br
			button.btn.btn-primary(@click.prevent='getLimparFiltro') Limpar
	br
	vue-element-loading(:active='isActive' spinner='bar-fade-scale' color='#428BCA')
	grid(
		ref="grid" 
		:url='urlDataSource'
		:columns='columns'
		:GridHeight="400"
		:GridPageable="true"
		:DSpageSize="8"
		:DSserverPaging="true"
		:DSschema="true"
		:DSschemaData="'data'"
		:DSschemaTotal="'total'"
		:DSschemaParse="parse"
		:GridPageablePageSizes="[1, 10, 20, 100]"
		:DSfilter="filter"
		:DSserverFiltering="true"
	)
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import PageHeader from '@/components/PageHeader'
import Grid from '@/components/Grid'

import GridTemplate from '@/mixins/GridTemplate'
import Permission from '@/mixins/Permission'
import TemplateCapa from './TemplateCapa'

import InputFormText from '@/components/form/InputForm'
import SelectForm from '@/components/form/SelectForm'

import { confirme, erro, sucesso } from '@/components/Message'
import req from '@/components/request'

import moment from 'moment'

export default {
	mixins: [GridTemplate, Permission],
	components: {
		VueElementLoading,
		PageHeader,
		Grid,
		InputFormText,
		SelectForm
	},
	computed: {
		filter() {
			return {
				logic: 'and',
				filters: [
					{
						field: 'title',
						operator: 'contains',
						value: this.filtro.title
					}
				]
			}
		},
		urlDataSource() {
			return `${this.$url}/classificados?destaque=8`
		}
	},
	watch: {
		'filtro.title' () {
			this.setFiltro()
		}
	},
	data() {
		return {
			title: 'Classificados',
			titleNew: '',
			url: '/sistema/classificados/',
			columns: [{
				template: this.getTemplateCapa,
				title: 'Capa',
				width: 40,
			}, {
				field: 'datacla',
				title: 'Data',
				width: 50
			}, {
				field: 'timecla',
				title: 'Hora',
				width: 50
			}, {
				field: 'title',
				title: 'Título',
				width: 200
			}, {
				field: 'active_nome',
				title: 'Ativo',
				width: 120
			}
			],
			filtro: {
				categoria: null,
				title: null,
			},
			isActive: false,
		}
	},
	methods: {
		parse(d) {
			d.data.map(i => {
				i.timecla = moment(new Date(`${i.datacla} ${i.timecla}`)).format('HH:mm')
				i.datacla = moment(i.datacla).format('DD/MM/YYYY')
				return i
			})
			return d
		},
		verifPermissao() {
			this.titleNew = this.ACTION.c ? 'Novo' : ''
			if (this.ACTION.e || this.ACTION.d) {
				this.columns.push({
					field: 'ativo',
					title: 'Ações',
					width: 105,
					template: this.commandTemplate
				})
			}
		},
		getTemplateCapa(e) {
			return {
				template: TemplateCapa,
				templateArgs: {
					data: e
				}
			}
		},
		setFiltro() {
			let filtro = {
				title: this.filtro.title,
			}
			localStorage.setItem('_filtroClassificados', JSON.stringify(filtro))
		},
		getLimparFiltro() {
			let filtro = {
				title: null,
			}
			localStorage.setItem('_filtroClassificados', JSON.stringify(filtro))
			this.filtro = filtro
		},
		async buttonClickApagar(item) {
			const result = await confirme(item.title,'Tem certeza que deseja remover esse registro? pois a exclusão é irreversível e não é possível voltar os dados')
			if(result.isConfirmed) {
				this.isActive = true
				await req(`/classificados/${item.id}`, 'delete').catch(() => {
					erro()
				})
				sucesso('Atualizado...')
				this.$refs.grid.$refs.datasource1.kendoDataSource.read()
			}
			this.isActive = false
		}
	},
	created() {
		this.verifPermissao()
		let filtro = localStorage.getItem('_filtroClassificados')
			? JSON.parse(localStorage.getItem('_filtroClassificados'))
			: null
		if (filtro) {
			this.filtro = filtro
		}
	}
}
</script>

<style lang="stylus" scoped>

</style>
